<template>
  <div>
    <header-component title="
      Mis citas y datos
      " map="false" />
    <rank-component />
    <div class="container">
      <br />
      <div class="columns">
        <!-- <div class="column"> -->
        <b-button type="is-primary" @click="irACita()" expanded>Crear una cita</b-button>
        <!-- </div> -->
      </div>
      <div class="columns">
        <div class="column">
          <h2 class="h2Title p-t-0">Mis citas</h2>
          <div class="columns">
            <div class="column">
              <b-menu>
                <b-menu-list type="warning" label="Citas presenciales pendientes">
                  <b-menu-item
                    class="blockInformation danger-block-header"
                    style="text-transform:capitalize;"
                    v-for="(ticket, index) in ticketsWarning"
                    :key="index"
                    icon="alert"
                    :label="ticket.sub_area_id + ' - ' + ticket.initialTime"
                    v-bind:class="{ 'has-text-warning': ticket.done == 1 }"
                  >
                    <div
                      v-if="ticket.done == 0"
                      v-bind:class="{
                        'has-text-warning': ticket.number == 1
                      }"
                    >
                      Código único de mi cita:
                      <div>
                        <b-icon icon="account-multiple"></b-icon>
                        <span v-if="ticket.number == 1">Es el siguiente en ser atendido.</span>
                        <span v-else>{{ ticket.number }}</span>
                      </div>
                    </div>
                    <div
                      v-if="ticket.worker_id"
                      v-bind:class="{
                        'has-text-warning': ticket.number == 1
                      }"
                    >
                      Trabajador:
                      <div>
                        <b-icon icon="account-tie"></b-icon>
                        {{ ticket.worker_id }}
                      </div>
                    </div>
                    <div v-if="ticket.documentos">
                      Documentos adicionados:
                      <div>
                        <b-icon icon="file-document"></b-icon>
                        {{ ticket.documents }}
                      </div>
                    </div>
                    <div
                      v-bind:class="{
                        'has-text-warning': ticket.number == 1
                      }"
                      class="has-text-primary"
                      v-if="ticket.done == 0"
                    >
                      Estado del trámite:
                      <div>
                        <b-icon icon="account-clock"></b-icon>En espera.
                      </div>
                    </div>
                    <div class="has-text-warning" v-if="ticket.done == 1">
                      Estado del trámite:
                      <div>
                        <b-icon icon="domain-plus"></b-icon>Recoger en la notaria.
                      </div>
                    </div>
                    <div class="has-text-success" v-if="ticket.done == 2">
                      Estado del trámite:
                      <div>
                        <b-icon icon="check-all"></b-icon>Finalizado.
                      </div>
                    </div>
                    <div class="has-text-primary" v-if="ticket.done == 0">
                      Fecha de creación:
                      <div>
                        <b-icon icon="alarm"></b-icon>
                        {{ ticket.initialTime }}
                      </div>
                    </div>
                    <div class="has-text-warning" v-if="ticket.done == 1">
                      Fecha de recojo:
                      <div>
                        <b-icon icon="alarm"></b-icon>
                        {{ ticket.initialTime }}
                      </div>
                    </div>
                    <div class="has-text-success" v-if="ticket.done == 2">
                      Fecha de finalización:
                      <div>
                        <b-icon icon="alarm"></b-icon>
                        {{ ticket.initialTime }}
                      </div>
                    </div>
                    <div v-if="ticket.done != 2">
                      Número telefónico de contácto:
                      <div>
                        <b-icon icon="cellphone"></b-icon>
                        {{ ticket.phone }}
                      </div>
                    </div>
                    <div v-if="ticket.done != 2">
                      Medio de comunicación:
                      <div>
                        <b-icon icon="cellphone-message"></b-icon>
                        {{ ticket.contactType }}
                      </div>
                    </div>
                  </b-menu-item>
                </b-menu-list>
                <b-menu-list label="Citas en espera">
                  <b-menu-item
                    class="blockInformation"
                    style="text-transform:capitalize;"
                    v-for="(ticket, index) in ticketsWaiting"
                    :key="index"
                    icon="text-box-search-outline"
                    :label="ticket.sub_area_id + ' - ' + ticket.initialTime"
                    v-bind:class="{ 'has-text-warning': ticket.done == 1 }"
                  >
                    <div
                      v-if="ticket.done == 0"
                      v-bind:class="{
                        'has-text-warning': ticket.number == 1
                      }"
                    >
                      Código único de mi cita:
                      <div>
                        <b-icon icon="account-multiple"></b-icon>
                        <span v-if="ticket.number == 1">Es el siguiente en ser atendido.</span>
                        <span v-else>{{ ticket.number }}</span>
                      </div>
                    </div>
                    <div
                      v-if="ticket.worker_id"
                      v-bind:class="{
                        'has-text-warning': ticket.number == 1
                      }"
                    >
                      Trabajador:
                      <div>
                        <b-icon icon="account-tie"></b-icon>
                        {{ ticket.worker_id }}
                      </div>
                    </div>
                    <div v-if="ticket.documentos">
                      Documentos adicionados:
                      <div>
                        <b-icon icon="file-document"></b-icon>
                        {{ ticket.documents }}
                      </div>
                    </div>
                    <div
                      v-bind:class="{
                        'has-text-warning': ticket.number == 1
                      }"
                      class="has-text-primary"
                      v-if="ticket.done == 0"
                    >
                      Estado del trámite:
                      <div>
                        <b-icon icon="account-clock"></b-icon>En espera.
                      </div>
                    </div>
                    <div class="has-text-warning" v-if="ticket.done == 1">
                      Estado del trámite:
                      <div>
                        <b-icon icon="domain-plus"></b-icon>Recoger en la notaria.
                      </div>
                    </div>
                    <div class="has-text-success" v-if="ticket.done == 2">
                      Estado del trámite:
                      <div>
                        <b-icon icon="check-all"></b-icon>Finalizado.
                      </div>
                    </div>
                    <div class="has-text-primary" v-if="ticket.done == 0">
                      Fecha de creación:
                      <div>
                        <b-icon icon="alarm"></b-icon>
                        {{ ticket.initialTime }}
                      </div>
                    </div>
                    <div class="has-text-warning" v-if="ticket.done == 1">
                      Fecha de recojo:
                      <div>
                        <b-icon icon="alarm"></b-icon>
                        {{ ticket.initialTime }}
                      </div>
                    </div>
                    <div class="has-text-success" v-if="ticket.done == 2">
                      Fecha de finalización:
                      <div>
                        <b-icon icon="alarm"></b-icon>
                        {{ ticket.initialTime }}
                      </div>
                    </div>
                    <div v-if="ticket.done != 2">
                      Número telefónico de contácto:
                      <div>
                        <b-icon icon="cellphone"></b-icon>
                        {{ ticket.phone }}
                      </div>
                    </div>
                    <div v-if="ticket.done != 2">
                      Medio de comunicación:
                      <div>
                        <b-icon icon="cellphone-message"></b-icon>
                        {{ ticket.contactType }}
                      </div>
                    </div>
                  </b-menu-item>
                </b-menu-list>
                <b-menu-list label="Citas completadas">
                  <b-menu-item
                    class="blockInformation"
                    style="text-transform:capitalize;"
                    v-for="(ticket, index) in ticketsComplete"
                    :key="index"
                    icon="text-box-check-outline"
                    :label="ticket.sub_area_id + ' - ' + ticket.initialTime"
                    v-bind:class="{ 'has-text-warning': ticket.done == 1 }"
                  >
                    <div
                    >
                      Código único de mi cita:
                      <div>
                        <b-icon icon="ticket"></b-icon>
                        <span>{{ ticket.number }}</span>
                      </div>
                    </div>
                    <div
                      v-if="ticket.worker_id"
                      v-bind:class="{
                        'has-text-warning': ticket.number == 1
                      }"
                    >
                      Trabajador:
                      <div>
                        <b-icon icon="account-tie"></b-icon>
                        {{ ticket.worker_id }}
                      </div>
                    </div>
                    <div v-if="ticket.documentos">
                      Documentos adicionados:
                      <div>
                        <b-icon icon="file-document"></b-icon>
                        {{ ticket.documents }}
                      </div>
                    </div>
                    <div
                      v-bind:class="{
                        'has-text-warning': ticket.number == 1
                      }"
                      class="has-text-primary"
                      v-if="ticket.done == 0"
                    >
                      Estado del trámite:
                      <div>
                        <b-icon icon="account-clock"></b-icon>En espera.
                      </div>
                    </div>
                    <div class="has-text-warning" v-if="ticket.done == 1">
                      Estado del trámite:
                      <div>
                        <b-icon icon="domain-plus"></b-icon>Recoger en la notaria.
                      </div>
                    </div>
                    <div class="has-text-success" v-if="ticket.done == 2">
                      Estado del trámite:
                      <div>
                        <b-icon icon="check-all"></b-icon>Finalizado.
                      </div>
                    </div>
                    <div class="has-text-primary" v-if="ticket.done == 0">
                      Fecha de creación:
                      <div>
                        <b-icon icon="alarm"></b-icon>
                        {{ ticket.initialTime }}
                      </div>
                    </div>
                    <div class="has-text-warning" v-if="ticket.done == 1">
                      Fecha de recojo:
                      <div>
                        <b-icon icon="alarm"></b-icon>
                        {{ ticket.initialTime }}
                      </div>
                    </div>
                    <div class="has-text-success" v-if="ticket.done == 2">
                      Fecha de finalización:
                      <div>
                        <b-icon icon="alarm"></b-icon>
                        {{ ticket.initialTime }}
                      </div>
                    </div>
                    <div v-if="ticket.done != 2">
                      Número telefónico de contácto:
                      <div>
                        <b-icon icon="cellphone"></b-icon>
                        {{ ticket.phone }}
                      </div>
                    </div>
                    <div v-if="ticket.done != 2">
                      Medio de comunicación:
                      <div>
                        <b-icon icon="cellphone-message"></b-icon>
                        {{ ticket.contactType }}
                      </div>
                    </div>
                  </b-menu-item>
                </b-menu-list>
              </b-menu>
            </div>
          </div>
        </div>
        <div class="column">
          <h2 class="h2Title p-t-0">Mis datos</h2>
          <div class="columns">
            <div class="column infoBlock">
              <div>
                <h3>Correo Electrónico:</h3>
                <p>{{ user.email }}</p>
              </div>
              <div>
                <h3>Nombre Completo:</h3>
                <p>{{ user.name }}</p>
              </div>
              <div>
                <h3>Documento de Identificación:</h3>
                <p>{{ user.di }}</p>
              </div>
              <div>
                <h3>Teléfono de Contacto:</h3>
                <p>{{ user.phone }}</p>
              </div>
              <div class="buttons">
                <b-button @click="salir()" type="is-danger">Cerrar mi cuenta</b-button>
                <b-button @click="modificarModal=true" type="is-primary">Cambiar mis datos</b-button>
              </div>
              <div>
                <h3
                  class="has-text-warning"
                >*El correo y el documento de identidad no pueden ser cambiados.</h3>
              </div>
              <!-- <b-button class="is-info" icon-left="account-edit">
                Editar datos
              </b-button>-->
            </div>
          </div>
        </div>
      </div>
      <b-modal :active.sync="setPuntaje" :width="640" scroll="keep">
        <div class="has-background-white calificacion">
          <div class="container">
            <h3 class="title is-4 t-calificacion">Califico mi cita <br />{{ticketDone.sub_area}}</h3>
            <h3
              class="subtitle is-5 b-calificacion"
            >con {{ticketDone.worker.toUpperCase()}} el {{ticketDone.initialTime}}</h3>
            <div class="buttons is-centered">
              <b-button @click="sendPuntaje(0)" type="is-primary">Malo</b-button>
              <b-button @click="sendPuntaje(3)" type="is-primary">Bueno</b-button>
              <b-button @click="sendPuntaje(5)" type="is-primary">Genial</b-button>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal :active.sync="modificarModal" :width="640" scroll="keep">
        <modificar-component />
      </b-modal>
    </div>
  </div>
</template>
<style lang="scss">
.calificacion{
  padding: 15px;
  .t-calificacion{
    padding-bottom: 10px;
  }
}
.blockInformation ul > div {
  padding-bottom: 15px;
}
.danger-block-header {
  > a span {
    color: $warning !important;
  }
  > a.is-active span {
    color: white !important;
  }
}
.infoBlock {
  > div {
    padding-bottom: 15px;
  }
  p {
    color: $p-color;
    padding-left: 15px;
  }
}
</style>
<script>
/*<img src="{{asset('img/notariaVilca.jpg')}}" />*/
import HeaderComponent from "@/components/HeaderComponent.vue";
import RankComponent from "@/components/RankComponent.vue";
import ModificarComponent from "@/components/ModificarComponent.vue";
export default {
  components: {
    HeaderComponent,
    RankComponent,
    ModificarComponent
  },
  mounted() {
    if (this.$store.state.login == false) {
      this.$router.push("/ingresar");
    }
    this.user = this.$store.state.user;
    console.log(this.$store.state.user);

    this.$http
      .post(
        this.$store.state.url + "/api/user/ticket",
        {},
        {
          headers: {
            Authorization: "Bearer " + this.$store.state.user.token
          }
        }
      )
      .then(response => {
        console.log("RESPONSE:", response.data.success);
        this.tickets = response.data.success.tickets;
        this.ticketsWaiting = this.tickets.filter(t => {
          return t.done == 0;
        });
        this.ticketsWarning = this.tickets.filter(t => {
          return t.done == 1;
        });
        this.ticketsComplete = this.tickets.filter(t => {
          return t.done == 2;
        });
      });
    this.$http
      .post(
        this.$store.state.url + "/api/user/getPuntaje",
        {},
        {
          headers: {
            Authorization: "Bearer " + this.$store.state.user.token
          }
        }
      )
      .then(response => {
        console.log("RESPONSE:", response.data);
        if (response.data.success) {
          this.ticketDone = response.data.success.ticket;
          if (this.ticketDone) {
            this.setPuntaje = true;
          }
        }
      });
  },
  filters: {
    estadoTicket(value) {
      if (value == 0) {
        return "En espera.";
      }
      if (value == 1) {
        return "Para recoger.";
      }
      if (value == 2) {
        return "Completado.";
      }
    }
  },
  methods: {
    sendPuntaje(points) {
      this.$http
        .post(
          this.$store.state.url + "/api/user/puntaje",
          {
            id: this.ticketDone.id,
            points: points
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.user.token
            }
          }
        )
        .then(response => {
          console.log("RESPONSE:", response.data);
          this.setPuntaje = false;
        });
    },
    irACita() {
      this.$router.push("/tramites");
    },
    salir() {
      this.$store.state.login = false;
      localStorage.clear();
      this.$router.push("/");
    },
    confirmUser() {
      this.$buefy.dialog.confirm({
        title: "Usuario no registrado",
        message: `Para poder iniciar consultas en linea es necesario que se registre.`,
        confirmText: "Registrarme",
        cancelText: "Seguir sin registro",
        type: "is-warning",
        hasIcon: true,
        icon: "card-account-details",
        onConfirm: () => this.$buefy.toast.open("User agreed")
      });
    }
  },
  data() {
    return {
      user: {},
      tickets: {},
      setPuntaje: false,
      ticketsWarning: {},
      ticketsComplete: {},
      ticketsWaiting: {},
      ticketDone: { id: null, worker: "", sub_area: "", initialTime: null },
      codigo: "",
      isActive: true,
      imgHome: process.env.MIX_APP_URL + "img/notariaVilca.jpg",
      cuerpoDocumento:
        "El contenido del documento aparecera aqui. Recuerde que solo tiene 3 consultas por dia.",
        modificarModal: false
    };
  }
};
</script>
